import { useGetOrganisation } from '@dhl/mdp-api'
import { convertToOrganisation } from '~/modules/organisations/model'

export const useOrganisation = (id: string | undefined) => {
  const { isFetching, data, refetch } = useGetOrganisation(id || '', {
    query: {
      enabled: !!id,
      select: convertToOrganisation,
    },
  })

  return { organisation: data, isFetching, refetchOrganisation: refetch }
}
